/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateClassificationWithSubClassifications {
    getFixupPrototypeFunction() { return TemplateClassificationWithSubClassifications.fixupPrototype; }

    static newInstance(model: Partial<TemplateClassificationWithSubClassifications>): TemplateClassificationWithSubClassifications {
        let obj = Object.assign(new TemplateClassificationWithSubClassifications(), model);
        TemplateClassificationWithSubClassifications.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateClassificationWithSubClassifications>): TemplateClassificationWithSubClassifications {
        if (!model) return null;
        return TemplateClassificationWithSubClassifications.newInstance(<TemplateClassificationWithSubClassifications> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateClassificationWithSubClassifications) {
        if (!obj) return;

        models.TemplateClassificationWithSubClassifications.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateClassificationWithSubClassifications): boolean {
        Object.setPrototypeOf(obj, TemplateClassificationWithSubClassifications.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Sub-classifications selected under Deployment
     */
    deployment: Array<models.DeploymentSubClassification>;

    /**
     * Sub-classifications selected under Operations
     */
    operations: Array<models.OperationsSubClassification>;

    /**
     * Sub-classifications selected under Provisioning
     */
    provisioning: Array<models.ProvisioningSubClassification>;

}
